import { Component, Input, Output, OnInit, OnChanges, EventEmitter, ViewChild, ElementRef, TemplateRef, ViewContainerRef, ViewRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core'
import { trigger, state, style } from '@angular/animations'
import { Movie } from '../../movies/movies.module'

@Component({
  selector: 'cm-invitation-modal',
  templateUrl: './invitation-modal.component.html',
  styleUrls: ['./invitation-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  // animations: [
  //   trigger('modalState', [
  //     state('open', style({
  //       bottom: ''
  //     }))
  //   ])
  // ]
})
export class InvitationModalComponent implements OnInit, OnChanges {

  @Input() movies: Movie[]

  @Input() height: number

  @Output() invite = new EventEmitter<Movie>()

  @ViewChild('header', {read: ViewContainerRef})
  private vcr: ViewContainerRef

  @ViewChild(TemplateRef)
  private templateRef: TemplateRef<any>

  public isOpened = false
  public isDragging = false
  public startY = 0
  public positionY = 0

  private viewRef: ViewRef

  constructor(private el: ElementRef,
    private cd: ChangeDetectorRef) { }

  ngOnInit() {
    // this.positionY = -this.getHeight()
  }

  ngOnChanges() {
    if (this.isOpened) {
      this.positionY = this.height
    }
  }

  onResize(event: any) {
    console.log('coucou')
    // this.positionY = -this.getHeight()
  }

  onClick(event: any) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.close()
    }
  }

  onPanStart(event: any) {
    event.preventDefault()
    this.isDragging = true
    this.startY = this.positionY
  }

  onPanEnd(event: any) {
    event.preventDefault()
    if (this.positionY >= this.height / 2) {
      this.open()
    } else {
      this.close()
    }

    this.isDragging = false
  }

  onPanMove(event: any) {
    event.preventDefault()

    if (this.isDragging) {
      this.positionY = this.startY - event.deltaY

      if (this.positionY < 0) {
        this.positionY = 0
      }

      if (this.positionY > this.height) {
        this.positionY = this.height
      }
    }
  }

  onInvite(movie?: Movie) {
    this.invite.emit(movie)
  }

  open() {
    this.isOpened = true
    this.positionY = this.height
  }

  close() {
    this.isOpened = false
    this.positionY = 0
  }

  toggle() {
    this.isOpened ? this.close() : this.open()
  }

  // private getHeight(): number {
  //   // console.log(document.documentElement.clientHeight)
  //   console.log(document.documentElement.clientHeight * 0.80)
  //   return document.documentElement.clientHeight * 0.80
  // }

}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/profile/invitation-modal/invitation-modal.component.ts